import React from 'react';
import { MessageSquare, Circle } from 'lucide-react';

const ChatHeader: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-red-600 to-red-500 text-white p-4 flex items-center justify-between rounded-t-3xl flex-shrink-0 shadow-lg">
      <div className="flex items-center">
        <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg mr-3 shadow-lg">
          <MessageSquare className="h-5 w-5 text-white" />
        </div>
        <div>
          <h1 className="font-bold text-lg">Gürsu AI Asistan</h1>
          <p className="text-xs opacity-90">Gürsu Belediyesi akıllı asistanı</p>
        </div>
      </div>
      <div className="flex items-center">
        <Circle className="h-2 w-2 text-green-300 fill-current mr-1" />
        <span className="text-xs opacity-90">Çevrimiçi</span>
      </div>
    </div>
  );
};

export default ChatHeader;